import React, { useState, useEffect } from 'react';
import { StoryblokComponent } from 'storyblok-js-client';
import { Props } from '../types';
import { filterProps } from '../helpers';
import { RocheContactCard } from './contact-card';

export const RocheContactList = (
  { blok, getComponent, slot }: Props<StoryblokComponent<string>>,
): JSX.Element => {
  const [contactList, setContactList] = useState([]);
  const { props } = filterProps(blok);

  // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
  const { contacts, ...requiredProps } = props;

  const allProps = {
    ...requiredProps,
    ...(slot ? { slot } : {}),
    // eslint-disable-next-line no-underscore-dangle
    ...(blok._uid ? { uid: blok._uid } : {}),
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'cards-length': blok.contacts.length,
  };

  const getContactCard = (item, i): JSX.Element => {
    if (!item) return null;
    // eslint-disable-next-line no-underscore-dangle
    const key = item._uid + i;
    const itemProps = {
      ...item,
      ...(allProps['cards-layout'] ? { layout: allProps['cards-layout'] } : {}),
    };

    return <RocheContactCard key={key} blok={itemProps} getComponent={getComponent} />;
  };

  useEffect(() => {
    setContactList(blok.contacts.map((contact) => contact.content));
  }, [blok.contacts]);

  return (
    <roche-contact-list {...allProps}>
      {contactList.map((item, i) => getContactCard(item, i))}
    </roche-contact-list>
  );
};
